import type { FC } from "react";

import classNames from "classnames";

import type { DirectionalIconComponent } from "@jti/brand-icons";

import styles from "./ItemFlag.module.scss";

export type SubscriptionItemFlagProps = {
  icon: DirectionalIconComponent;
  text: string;
  className?: string;
};

export const ItemFlag: FC<SubscriptionItemFlagProps> = ({ icon, text, className }) => {
  const Icon = icon;

  return (
    <div className={classNames(styles.container, className)}>
      <Icon className={styles.icon} />
      <span className={styles.caption}>{text}</span>
    </div>
  );
};
